import type { DocumentChunkSource, PccDataSource } from '@ss/typings/nta-hunter';
import { PccDataSidePanelTypes } from '@ss/typings/pcc';

export const PATIENT_POPOUT_PROTOCOL_VERSION = 1 as const;

export const PATIENT_POPOUT_SHELL_SESSION_STORAGE_KEY = 'ntaPatientPopoutShellSession';

export enum PatientPopoutMessageType {
	SHELL_DISCONNECTING = 'SHELL_DISCONNECTING',
	SET_PATIENT = 'SET_PATIENT',
	PATIENT_READY = 'PATIENT_READY',
	SET_SIDE_PANEL = 'SET_SIDE_PANEL',
	VIEW_SOURCE = 'VIEW_SOURCE',
	GO_TO_FILE = 'GO_TO_FILE',
	GO_TO_GENERATED_DOCUMENT = 'GO_TO_GENERATED_DOCUMENT',
	GO_TO_ADR_PREVIEW = 'GO_TO_ADR_PREVIEW',
	GO_TO_PCC_DATA_PANEL = 'GO_TO_PCC_DATA_PANEL',
	POPOUT_READY = 'POPOUT_READY',
	POPOUT_CLOSED = 'POPOUT_CLOSED'
}

export type ShellDisconnectReason = 'refresh' | 'navigate_away' | 'close_tab' | 'close_popout';

export type PatientPopoutSidePanel = 'pdf' | 'generated' | 'aichat' | 'adr' | 'pccData';

export type PatientPopoutEndpoint = 'main' | 'popout';

type Base = { protocolVersion: typeof PATIENT_POPOUT_PROTOCOL_VERSION; from: PatientPopoutEndpoint };

export type PatientPopoutMessage =
	| Base & { type: PatientPopoutMessageType.SHELL_DISCONNECTING; reason?: ShellDisconnectReason }
	| Base & { type: PatientPopoutMessageType.SET_PATIENT; patientId: string; facilityId: string }
	| Base & { type: PatientPopoutMessageType.PATIENT_READY; patientId: string }
	| Base & { type: PatientPopoutMessageType.SET_SIDE_PANEL; patientId: string; panel: PatientPopoutSidePanel }
	| Base & { type: PatientPopoutMessageType.VIEW_SOURCE; patientId: string; source: DocumentChunkSource | PccDataSource }
	| Base & { type: PatientPopoutMessageType.GO_TO_FILE; patientId: string; fileId: string }
	| Base & { type: PatientPopoutMessageType.GO_TO_GENERATED_DOCUMENT; patientId: string; fileId?: string; docIndex?: number }
	| Base & { type: PatientPopoutMessageType.GO_TO_ADR_PREVIEW; patientId: string; packetId: string; page?: number; searchQuote?: string }
	| Base & { type: PatientPopoutMessageType.GO_TO_PCC_DATA_PANEL; patientId: string; pccDataListType: PccDataSidePanelTypes; pccDataItemId: number; adrDialogPacketId?: string; errorMessage?: string }
	| Base & { type: PatientPopoutMessageType.POPOUT_READY; patientId: string }
	| Base & { type: PatientPopoutMessageType.POPOUT_CLOSED };

export type PatientPopoutPostPayload = PatientPopoutMessage extends infer T
	? T extends PatientPopoutMessage
		? Omit<T, 'from'> & { from?: PatientPopoutEndpoint }
		: never
	: never;
